import view from './information.view.html';
import './information.scss';
import { BUILDER_PAYMENT_PROVIDER_BLIP_CLICKED } from '../../../events';
class InformationController {
    static $inject = ['PaymentSegmentService'];
    //#endregion
    constructor(PaymentSegmentService) {
        this.informationData = {
            description: '',
            notes: '',
        };
        //#region Lifecycle Hooks
        this.$onInit = () => {
            if (this.state && this.PaymentSegmentService?.setState) {
                this.PaymentSegmentService.setState(this.state);
            }
        };
        //#endregion
        //#region Methods
        this.saveToJSON = () => {
            if (this.onInformationChange) {
                this.onInformationChange({ informationData: this.informationData });
            }
            return JSON.stringify(this.informationData, null, 2);
        };
        this.openBlipProviderLink = () => {
            window.open('https://blip-ai.notion.site/273dcfddcf4a8094b971e9af9a5922ba', '_blank');
            this.trackClickButton();
        };
        this.PaymentSegmentService = PaymentSegmentService;
    }
    //#endregion
    //#region tracking    
    trackClickButton() {
        this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_PROVIDER_BLIP_CLICKED);
    }
}
export const Information = {
    controller: InformationController,
    controllerAs: '$ctrl',
    template: view,
    bindings: {
        stateId: '<',
        state: '<',
        onInformationChange: '&?',
    },
};
